import { render, staticRenderFns } from "./SelectVideo.vue?vue&type=template&id=3dcce74e&"
import script from "./SelectVideo.vue?vue&type=script&lang=js&"
export * from "./SelectVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports